<template>
  <div class="mates-info">
    <h6>{{ members.length }} Teammates</h6>
    <div class="mates-image-wrap">
      <div
        class="mates-image position-relative"
        v-for="user in members.slice(0, 7)"
        :key="user.id"
      >
        <abbr :title="user.username">
        <div class="users-notification" v-if="imgLoader == 1">
          <img src="../../assets/loader.gif" alt="" />
        </div>
        <!-- <img
          :src="user.avatar"
          onerror="this.src='https://api.whoifollow.tech/user-default2.png'"

          alt=""
        /> -->
        <img
            @load="onImageLoad"
            :src="$userProfileStorageURL + user.c_id +'/profile_picture.jpg?v='+$time"
            onerror="this.src='https://api.whoifollow.tech/user-default2.png'"

          alt=""
        />
        </abbr>
      </div>
    </div>
    <h6 v-if="members.length > 7">+{{ members.length-7 }} more </h6>
  </div>
</template>

<script>
export default {
  props: {
    members: {
      type: Array,
    },
  },
  data() {
    return {
      imgLoader: 1,
    };
  },
  methods: {
    onImageLoad() {
      this.imgLoader = 0;
    },
  },
};
</script>

<style>
</style>